/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, typeCast, delegateCombine, delegateRemove, markType } from "igniteui-react-core";
import { IAnnotationLayerProxy_$type } from "./IAnnotationLayerProxy";
import { CrosshairLayer } from "./CrosshairLayer";
import { ValueLayer } from "./ValueLayer";
import { CalloutLayer } from "./CalloutLayer";
import { FinalValueLayer } from "./FinalValueLayer";
import { DataToolTipLayer } from "./DataToolTipLayer";
import { DoubleCollection } from "igniteui-react-core";
/**
 * @hidden
 */
var AnnotationLayerProxy = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AnnotationLayerProxy, _super);
    function AnnotationLayerProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._container = null;
        return _this;
    }
    Object.defineProperty(AnnotationLayerProxy.prototype, "container", {
        get: function () {
            return this._container;
        },
        set: function (a) {
            this._container = a;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationLayerProxy.prototype.matchesType = function (a) {
        if (!a.dd) {
            return false;
        }
        return true;
    };
    AnnotationLayerProxy.prototype.createCrosshairLayer = function () {
        var a = new CrosshairLayer();
        var b = this.container.getExternal(a, null, null);
        return a;
    };
    AnnotationLayerProxy.prototype.createValueLayer = function () {
        var a = new ValueLayer();
        var b = this.container.getExternal(a, null, null);
        return a;
    };
    AnnotationLayerProxy.prototype.createCalloutLayer = function () {
        var a = new CalloutLayer();
        var b = this.container.getExternal(a, null, null);
        return a;
    };
    AnnotationLayerProxy.prototype.createFinalValueLayer = function () {
        var a = new FinalValueLayer();
        var b = this.container.getExternal(a, null, null);
        return a;
    };
    AnnotationLayerProxy.prototype.setCrosshairHorizontalLineVisibility = function (a, b) {
        a.v2 = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairVerticalLineVisibility = function (a, b) {
        a.v3 = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairHorizontalLineStroke = function (a, b) {
        a.vq = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairVerticalLineStroke = function (a, b) {
        a.vr = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairXAxisForeground = function (a, b) {
        a.vu = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairYAxisForeground = function (a, b) {
        a.vx = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairXAxisBackground = function (a, b) {
        a.vs = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairYAxisBackground = function (a, b) {
        a.vv = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairYAxisPrecision = function (a, b) {
        a.tz = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairXAxisPrecision = function (a, b) {
        a.ty = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairOnAxesEnabled = function (a, b) {
        a.th = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairUseInterpolation = function (a, b) {
        a.tj = b;
    };
    AnnotationLayerProxy.prototype.setCrosshairThickness = function (a, b) {
        a.g4 = b;
    };
    AnnotationLayerProxy.prototype.setFinalValuePrecision = function (a, b) {
        a.to = b;
    };
    AnnotationLayerProxy.prototype.setFinalValueBackground = function (a, b) {
        a.ui = b;
    };
    AnnotationLayerProxy.prototype.setFinalValueForeground = function (a, b) {
        a.uk = b;
    };
    AnnotationLayerProxy.prototype.setContentMemberPath = function (a, b) {
        a.vr = b;
    };
    AnnotationLayerProxy.prototype.setCalloutsAllowedPositions = function (a, b) {
        a.tm = b;
    };
    AnnotationLayerProxy.prototype.setLabelMemberPath = function (a, b) {
        a.v1 = b;
    };
    AnnotationLayerProxy.prototype.setXMemberPath = function (a, b) {
        a.wc = b;
    };
    AnnotationLayerProxy.prototype.setYMemberPath = function (a, b) {
        a.wf = b;
    };
    AnnotationLayerProxy.prototype.setTargetSeries = function (a, b) {
        a.tq = b;
    };
    AnnotationLayerProxy.prototype.setCollisionChannel = function (a, b) {
        a.vo = b;
    };
    AnnotationLayerProxy.prototype.setIsAutoCalloutBehaviorEnabled = function (a, b) {
        a.ue = b;
    };
    AnnotationLayerProxy.prototype.setGreedyCollisionMode = function (a, b) {
        a.th = b ? 2 : 0;
    };
    AnnotationLayerProxy.prototype.setUseDedicatedLanes = function (a, b) {
        a.tf = b ? 2 : 0;
    };
    AnnotationLayerProxy.prototype.isCalloutLayer = function (a) {
        if (typeCast(CalloutLayer.$, a) !== null) {
            return true;
        }
        return false;
    };
    AnnotationLayerProxy.prototype.isDataToolTipLayer = function (a) {
        if (typeCast(DataToolTipLayer.$, a) !== null) {
            return true;
        }
        return false;
    };
    AnnotationLayerProxy.prototype.addCalloutStyleUpdating = function (a, b) {
        var c = a;
        c.calloutStyleUpdating = delegateCombine(c.calloutStyleUpdating, b);
    };
    AnnotationLayerProxy.prototype.removeCalloutStyleUpdating = function (a, b) {
        var c = a;
        c.calloutStyleUpdating = delegateRemove(c.calloutStyleUpdating, b);
    };
    AnnotationLayerProxy.prototype.addCalloutRenderStyleUpdating = function (a, b) {
        var c = a;
        c.calloutRenderStyleUpdating = delegateCombine(c.calloutRenderStyleUpdating, b);
    };
    AnnotationLayerProxy.prototype.removeCalloutRenderStyleUpdating = function (a, b) {
        var c = a;
        c.calloutRenderStyleUpdating = delegateRemove(c.calloutRenderStyleUpdating, b);
    };
    AnnotationLayerProxy.prototype.setCalloutStyleUpdatingEventEnabled = function (a, b) {
        a.uh = b;
    };
    AnnotationLayerProxy.prototype.setCalloutRenderStyleUpdatingEventEnabled = function (a, b) {
        a.ug = b;
    };
    AnnotationLayerProxy.prototype.updateDataToolTipPropertyByName = function (a, b, c) {
        a.yo(b, c);
    };
    AnnotationLayerProxy.prototype.setValueMode = function (a, b) {
        a.tg = b;
    };
    AnnotationLayerProxy.prototype.setValueAxisAnnotationEnabled = function (a, b) {
        a.tk = b;
    };
    AnnotationLayerProxy.prototype.setBrush = function (a, b) {
        a.o9 = b;
    };
    AnnotationLayerProxy.prototype.setDashArray = function (a, b) {
        var c = new DoubleCollection();
        for (var d = 0; d < b.length; d++) {
            c.add(b[d]);
        }
        a.pi = c;
    };
    AnnotationLayerProxy.$t = markType(AnnotationLayerProxy, 'AnnotationLayerProxy', Base.$, [IAnnotationLayerProxy_$type]);
    return AnnotationLayerProxy;
}(Base));
export { AnnotationLayerProxy };
